/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_No_Organizations_DescriptionInputs */



/**
* | output |
* | --- |
* | "No organizations are associated with this account. Please contact your administrator." |
*
* @param {Auth_Sso_No_Organizations_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_no_organizations_description = /** @type {((inputs?: Auth_Sso_No_Organizations_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_No_Organizations_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesem Konto sind keine Organisationen zugeordnet. Bitte kontaktiere deinen Administrator.")
	return /** @type {LocalizedString} */ ("No organizations are associated with this account. Please contact your administrator.")
});